import { ICellRendererParams } from 'ag-grid-community';
import { useState } from 'react';
import { getEnvConfig } from '../../../config/config';
import { formatTeamName } from '../../utilities/utilities';
import styles from './teamCell.module.scss';

const TeamCell = ({ value }: Partial<ICellRendererParams>) => {
  const [teamLogoLoaded, setTeamLogoLoaded] = useState(false);
  const { name, id, isHomeTeam, isAwayTeam } = value;
  const teamUrl = getEnvConfig().teamUrl;
  const siteUrl = /\/$/.test(getEnvConfig().site) ? getEnvConfig().site : `${getEnvConfig().site}/`;

  const location = () => {
    if (isHomeTeam) {
      return (
        <abbr title="Versus" className={`${styles.label} ${styles.vs}`}>
          Vs
        </abbr>
      );
    }
    if (isAwayTeam) {
      return <span className={`${styles.label} ${styles.at}`}>At</span>;
    }

    return '';
  };

  const loaded = () => {
    setTeamLogoLoaded(true);
  };

  let teamLogo;

  if (id) {
    teamLogo = new Image();
    teamLogo.src = `${siteUrl}${id}/Logo`;
    teamLogo.addEventListener('load', loaded);
  }

  return name ? (
    <a
      data-testid="PT-teamCell-teamLink"
      className={styles.team}
      href={`${teamUrl}${id}&a=Index&c=VenueTeam`}
    >
      {teamLogo && teamLogoLoaded && <img src={teamLogo.src} alt="" className={styles.teamLogo} />}
      {location()}
      <span
        title={name}
        className={`${styles.teamName} ${!isAwayTeam && !isHomeTeam ? styles.teamNameSpace : ''}`}
      >
        {formatTeamName(name)}
      </span>
    </a>
  ) : (
    <strong>/</strong>
  );
};

export { TeamCell };
